const UnexpectedError = "Unexpected error happened. Please try again.";
const SaveSuccess = "Save Success!";

export const AlertMessages = {
  UnexpectedError,
  SaveSuccess,
};
